import { t } from "i18next";
import CustomButtonColor from "../../Components/custom-button/CustomButtonColor";
import './ButtonStepForm.css';
import { nextStep, paymenttransfer, previousStep, splitAddress, validateAgentCode } from "../../Services/api-service";
import { useEffect } from "react";
import { countVietnameseChars, isNullOrEmpty, isObjectValid, isValidAddress } from "../../Services/service";
import { warning } from "../../Components/custom-toast/CustomToast";
function ButtonStepFormWidget({state, setState, objectDto, setObjectDto, setIsLoading, imgBack, imgFront}){
    const handlePreviousStep=()=>{
        setIsLoading(true);
        previousStep(objectDto, setObjectDto, setIsLoading);
        return setState(false);
    }
    const handleNextStep=async()=>{
        setIsLoading(true);
        if(objectDto.step === 2) {
            if(!objectDto.flagConfirm || !objectDto.flagFatca || !objectDto.flagInfo) {
                setObjectDto({step: -2});
                localStorage.clear();
                setIsLoading(false);
                return setState(false);
            }
        }
        if(objectDto.step === 3){
            if(objectDto.idnumber.length != 12) {
                setIsLoading(false);
                warning(t("errorlengthidnumber"));
                return setState(false);
            }
            if(countVietnameseChars(objectDto.address)){
                warning(t("errorlengthaddress"));
                setIsLoading(false);
                return setState(false);
            } 
            if(countVietnameseChars(objectDto.contactAddress)){
                warning(t("errorlengthcontactaddress"));
                setIsLoading(false);
                return setState(false);
            }
            if(!isValidAddress(objectDto.address)){
                warning(t("erroronecharacteraddress"));
                setIsLoading(false);
                return setState(false);
            }
            if(!isValidAddress(objectDto.contactAddress)){
                warning(t("erroronecharactercontactaddress"));
                setIsLoading(false);
                return setState(false);
            }
            if(isNullOrEmpty(objectDto.agentNumber)) {
            }else{
                const validateAgent = await validateAgentCode(objectDto, setIsLoading);
                if(!validateAgent) {
                    return;
                }
            }
        }
        // this one is for test performance - infras
        // if(objectDto.step === 3) {
        //     nextStep({...objectDto, step: 4, fileBack: imgBack, fileFront: imgFront, idtype: 0}, setObjectDto, setIsLoading);
        //     return setState(false);
        // }
        nextStep(objectDto, setObjectDto, setIsLoading);
        return setState(false);
    }
    
    useEffect(()=>{
        if(objectDto.step === 3){
            if(isObjectValid(objectDto, imgBack, imgFront, setObjectDto)) 
            {
                if(!state) setState(true);
            }else{
                setState(false);
            }
        }
    },[objectDto, imgBack, imgFront]);

    const handlePayment = () => {
        paymenttransfer(objectDto);
        // this one is for test performance - infras
        // setObjectDto({...objectDto, step: 8, paymentStatus: 1});
        // return setState(false);
    }

    return(
        objectDto.step === 6 ? <></>
        :
        <div className="wrap-list-button">
            <CustomButtonColor title={t("return")} color={"white"} borderRadius={"5px"} bgColor={"#c59812"} onClick={handlePreviousStep}/>
            {
                objectDto.step === 7 ? 
                    <CustomButtonColor title={t("btnpayment")} color={"white"} borderRadius={"5px"} bgColor={"#c59812"} onClick={handlePayment}/>
                    :
                    <CustomButtonColor title={objectDto.step === 4 ? t("agree") : t("continue")} color={state ? "white" : "black"} borderRadius={"5px"} bgColor={state ? "#c59812" : "#F2F2F7"} onClick={state ? handleNextStep : ()=>{}}/>
            }
        </div>
    )
}
export default ButtonStepFormWidget;